"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MouseButtonCodes = exports.MimeType = exports.Direction = exports.KeyCodes = void 0;
var KeyCodes;
(function (KeyCodes) {
    KeyCodes[KeyCodes["Right"] = 39] = "Right";
    KeyCodes[KeyCodes["Left"] = 37] = "Left";
    KeyCodes[KeyCodes["Up"] = 38] = "Up";
    KeyCodes[KeyCodes["Down"] = 40] = "Down";
    KeyCodes[KeyCodes["Escape"] = 27] = "Escape";
    KeyCodes[KeyCodes["Tab"] = 9] = "Tab";
    KeyCodes[KeyCodes["Meta"] = 91] = "Meta";
    KeyCodes[KeyCodes["Delete"] = 46] = "Delete";
    KeyCodes[KeyCodes["BackSpace"] = 8] = "BackSpace";
    KeyCodes[KeyCodes["Enter"] = 13] = "Enter";
    KeyCodes[KeyCodes["A"] = 65] = "A";
    KeyCodes[KeyCodes["SPACE"] = 32] = "SPACE";
    KeyCodes[KeyCodes["ALT"] = 18] = "ALT";
    KeyCodes[KeyCodes["C"] = 67] = "C";
    KeyCodes[KeyCodes["Home"] = 36] = "Home";
    KeyCodes[KeyCodes["End"] = 35] = "End";
    KeyCodes[KeyCodes["PageDown"] = 34] = "PageDown";
    KeyCodes[KeyCodes["PageUp"] = 33] = "PageUp";
    KeyCodes[KeyCodes["Z"] = 90] = "Z";
    KeyCodes[KeyCodes["CapsLock"] = 20] = "CapsLock";
    KeyCodes[KeyCodes["KEY_B"] = 66] = "KEY_B";
    KeyCodes[KeyCodes["KEY_I"] = 73] = "KEY_I";
    KeyCodes[KeyCodes["KEY_U"] = 85] = "KEY_U";
    KeyCodes[KeyCodes["KEY_X"] = 88] = "KEY_X";
    KeyCodes[KeyCodes["KEY_L"] = 76] = "KEY_L";
    KeyCodes[KeyCodes["KEY_E"] = 69] = "KEY_E";
    KeyCodes[KeyCodes["KEY_R"] = 82] = "KEY_R";
    KeyCodes[KeyCodes["BACK_SLASH"] = 220] = "BACK_SLASH";
    KeyCodes[KeyCodes["KEY_Y"] = 89] = "KEY_Y";
    KeyCodes[KeyCodes["ScrollLock"] = 145] = "ScrollLock";
    KeyCodes[KeyCodes["NumLock"] = 144] = "NumLock";
    KeyCodes[KeyCodes["Pause"] = 19] = "Pause";
    KeyCodes[KeyCodes["Insert"] = 45] = "Insert";
    KeyCodes[KeyCodes["F1"] = 112] = "F1";
    KeyCodes[KeyCodes["F2"] = 113] = "F2";
    KeyCodes[KeyCodes["F3"] = 114] = "F3";
    KeyCodes[KeyCodes["F4"] = 115] = "F4";
    KeyCodes[KeyCodes["F5"] = 116] = "F5";
    KeyCodes[KeyCodes["F6"] = 117] = "F6";
    KeyCodes[KeyCodes["F7"] = 118] = "F7";
    KeyCodes[KeyCodes["F8"] = 119] = "F8";
    KeyCodes[KeyCodes["F9"] = 120] = "F9";
    KeyCodes[KeyCodes["F10"] = 121] = "F10";
    KeyCodes[KeyCodes["F11"] = 122] = "F11";
    KeyCodes[KeyCodes["F12"] = 123] = "F12";
})(KeyCodes = exports.KeyCodes || (exports.KeyCodes = {}));
var Direction;
(function (Direction) {
    Direction["Up"] = "UP";
    Direction["Down"] = "DOWN";
    Direction["Left"] = "LEFT";
    Direction["Right"] = "RIGHT";
})(Direction = exports.Direction || (exports.Direction = {}));
var MimeType;
(function (MimeType) {
    MimeType["html"] = "text/html";
    MimeType["csv"] = "text/csv";
    MimeType["plain"] = "text/plain";
    MimeType["json"] = "application/json";
})(MimeType = exports.MimeType || (exports.MimeType = {}));
var MouseButtonCodes;
(function (MouseButtonCodes) {
    MouseButtonCodes[MouseButtonCodes["left"] = 1] = "left";
    MouseButtonCodes[MouseButtonCodes["middle"] = 2] = "middle";
    MouseButtonCodes[MouseButtonCodes["right"] = 3] = "right";
})(MouseButtonCodes = exports.MouseButtonCodes || (exports.MouseButtonCodes = {}));
//# sourceMappingURL=types.js.map